export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fff08c0dc0d1e8b893e024c66e99ecda8bba78145&name=fetchTypeahead!'